export class ViewItemListEvent {
  data = {
    item: []
  };

  setData(json, campaign) {
    const productJson = JSON.parse(json);
    let productDiscount = 0;
    let productPriceWithoutDiscount = (productJson.variants[0].price / 100);
    let productDiscountPercentage = 0;

    if (productJson.variants[0].compare_at_price) {
      productDiscount = (productJson.variants[0].compare_at_price - productJson.variants[0].price) / 100;
      productPriceWithoutDiscount = (productJson.variants[0].compare_at_price / 100);
      productDiscountPercentage = Math.round((productDiscount * 100) / productPriceWithoutDiscount);
    }

    const productCategoriesSplitted = productJson.type.split(' > ');
    const removedFirstCategory = productCategoriesSplitted.shift();
    const productCategories = [];

    let itemListName = '';
    const pathName = window.location.pathname.split('/').filter(i => i)[0];
    switch (pathName) {
      case undefined:
        itemListName = 'home';
        break;
      case 'collections':
        itemListName = 'grid';
        break;
      case 'products':
        itemListName = 'view_item';
        break;
    }

    productCategoriesSplitted.forEach((category, index) => {
      if (index === 0) {
        productCategories.push({
          'title': productCategoriesSplitted.join('|')
        });
      }

      productCategories.push({
        'title': category
      })
    });

    let indexes = Object.keys(productCategories);
    if (indexes.length <= 6) {
      for (let i = indexes.length; i < 6; i++) {
        productCategories.push({
          'title': ''
        });
      }
    }

    const dtLanguage = this.getLanguage();

    this.data.item.push({
      'item_name': productJson.title,
      'item_id': productJson.variants[0].id,
      'ean': productJson.variants[0].barcode,
      'id_reference': productJson.variants[0].id,
      'price': productPriceWithoutDiscount,
      'price_without_discount': productPriceWithoutDiscount.toFixed(2),
      'discount': productDiscount.toFixed(2),
      'discount_percentage': productDiscountPercentage,
      'item_brand': productJson.vendor,
      'price_sin_iva': '',
      'price_without_discount_sin_iva': '',
      'discount_sin_iva': '',
      'item_variant': (productJson.tags) ? productJson.tags.join('|') : '',
      'is_in_stock': (productJson.variants[0].available) ? 'yes' : 'no',
      'image': 'https:' + productJson.featured_image,
      'url': `${window.location.origin}/products/${productJson.handle}`,
      'quantity': 1,
      'item_list_name': itemListName,
      'currency': 'EUR',
      'is_on_sale': (productDiscount > 0) ? 'yes' : 'no',
      'added_date': productJson.created_at.substring(0, 10),
      'mercado': dtLanguage.mercado,
      'idioma': dtLanguage.idioma,
      'pca': '',
      'pcb': '',
      'pcpym': '',
      'pcz': '',
      'platform': this.getPlatformCookie(),
      'item_promotion_name': campaign.contents[0].data.ctcampaignName || '',
      'item_promotion_id': `${campaign.advertiserId}|${campaign.campaignId}` || '',
      'item_creative_slot': campaign.contents[0].data.ctcreativeSlot || '',
      'item_creative_name': campaign.contents[0].data.cttitle || '',
      'item_location_id': `${campaign.flightId}${campaign.creativeId}|${campaign.adId}` || '',
      'item_ad_name': campaign.contents[0].data.cttitle || '',
      'item_ad_type': 'rmsproduct',
      'item_category': productCategories[0].title,
      'item_category2': productCategories[1].title,
      'item_category3': productCategories[2].title,
      'item_category4': productCategories[3].title,
      'item_category5': productCategories[4].title,
      'item_category6': productCategories[5].title,
    })

    if (!window.__cartEventSent) {
      window.__cartEventSent = true;
      this.fetchCartAndPushData();
    }
  }

  getLanguage() {
    const lang = document.getElementsByTagName('html')[0].getAttribute('lang').toUpperCase();
    const market = 'ESP';

    return {
      mercado: market,
      idioma: lang
    }
  }

  getPlatformCookie() {
    let platform = localStorage.getItem('fd_platform');
    return platform ? platform : this.setPlatformCookie();
  }

  setPlatformCookie() {
    let platform = 'Web';
    if (window.navigator?.userAgent) {
      if (window.navigator.userAgent.indexOf('fdirect') !== -1) {
        platform = 'App';
      }
    }
    localStorage.setItem('fd_platform', platform);
    return platform;
  }

  async getCartObject() {
    return await fetch(`${window.Shopify.routes.root}cart.js`).then(response => response.json());
  }

  async fetchCartAndPushData() {
    try {
      const cart = await this.getCartObject();

      if (cart != undefined) {
        this.data.cart_id = cart.token;
        this.data.date_created__cart = cart.attributes?.['cart-date'];
        this.data.date_update__cart = cart.attributes?.['cart-date'];
        this.data.total_quantity_cart = cart.item_count;
        this.data.total_price_cart = cart.total_price / 100;
      }

      if (this.data.item.length > 0) {
        fdGtag('view_item_list', this.data.item);
        window.__cartEventSent = false;
      }
    } catch (error) {
      console.error('Error al obtener el carrito:', error);
    }
  }
}